import { render, staticRenderFns } from "./PopoverEmojis.vue?vue&type=template&id=3fb48e7a&scoped=true"
import script from "./PopoverEmojis.vue?vue&type=script&lang=js"
export * from "./PopoverEmojis.vue?vue&type=script&lang=js"
import style0 from "./PopoverEmojis.vue?vue&type=style&index=0&id=3fb48e7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb48e7a",
  null
  
)

export default component.exports